import api from './axios';

export const listarItens  = ()              => api.get('/carrinho/');
export const upsertItem   = (data)          => api.post('/carrinho/itens', data);
export const removerItem  = (id)            => api.delete(`/carrinho/itens/${id}`);
export const fecharPedido = (data)          => api.post('/carrinho/fechar', data);
export const areasDisponiveis = ()          => api.get('/carrinho/areas-disponiveis');
